import { createSelector } from '@reduxjs/toolkit';
import { FDealType, FOfferType } from '../../../../packages/JsonQuery';
import { selectDealType } from 'shared/selectors/jsonQuery';

export const selectObjectTypeOptions = createSelector(selectDealType, value => {
  switch (value) {
    case FDealType.Sale:
      return [
        { label: 'Неважно', value: FOfferType.Flat },
        { label: 'Новостройки', value: FOfferType.FlatNew },
        { label: 'Вторичка', value: FOfferType.FlatOld },
      ];
    case FDealType.RentLongterm:
      return [
        { label: 'Квартира', value: FOfferType.FlatOld },
        { label: 'Комната', value: FOfferType.Room },
        { label: 'Койко-место', value: FOfferType.Bed },
        { label: 'Дом, дача', value: FOfferType.House },
        { label: 'Часть дома', value: FOfferType.HousePart },
        { label: 'Таунхаус', value: FOfferType.Townhouse },
        { label: 'Гараж', value: FOfferType.Garage },
      ];
    default:
      return [];
  }
});
